import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
export const canvasContentVersionSwitchedEvent = EVENT_PAYLOAD;
export const canvasContentFullScreenClickedEvent = EVENT_PAYLOAD;
// Keep these shared literals pinned to ShareFileFailureReason until the backend
// taxonomy moves into a package that can be imported by the browser bundle.
export const SHARE_FILE_FAILURE_REASON = {
    TIMEOUT: 'timeout',
    EXCEPTION: 'exception',
};
export const canvasOpenedEvent = EVENT_PAYLOAD;
export const canvasContentDownloadedEvent = EVENT_PAYLOAD;
// Fires when the print dialog opens; the browser does not report whether the user printed.
export const canvasContentPrintedEvent = EVENT_PAYLOAD;
// A link artifact (EXTERNAL_URL asset) opens its outbound URL in a new tab
// rather than an in-app canvas, so it needs its own event. `surface` records
// where the click happened; `domain` is the host only (no full URL/path).
export const linkArtifactOpenedEvent = EVENT_PAYLOAD;
export const canvasWebsitePublishEvent = EVENT_PAYLOAD;
//# sourceMappingURL=analytics.js.map